import { hashSHA256 } from './helpers';

/**
 * Invia un evento al DataLayer di Google Tag Manager
 */
function pushToDataLayer(data: Record<string, unknown>): void {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push(data);
  } else {
    console.warn('DataLayer is not available');
  }
}

/**
 * Invia un evento GA generico
 */
export function sendGAEvent(
  eventAction: string,
  eventLabel: string,
  eventValue?: string
): void {
  pushToDataLayer({
    event: 'gaEvent',
    eventCategory: 'Formslider',
    eventAction,
    eventLabel,
    ...(eventValue && { eventValue }),
  });
}

/**
 * Mappa delle slide con i loro step values per il tracking
 */
export const SLIDE_STEP_VALUES: Record<string, string> = {
  location_form: '1',
  customer_type: '2',
  house_type: '3',
  name_form: '4',
  email_form: '5',
  phone_form: '6',
};

/**
 * Traccia la risposta a una slide
 */
export function trackSlideAnswer(
  slideId: string,
  slideTitle: string,
  answerValue: string
): void {
  const stepValue = SLIDE_STEP_VALUES[slideId] || '0';

  // Slide form hanno azioni specifiche
  const formSlideActions: Record<string, string> = {
    location_form: 'address_form',
    name_form: 'contact_form_nameFormSlide',
    email_form: 'contact_form_emailFormSlide',
    phone_form: 'contact_form_phoneFormSlide',
  };

  const action = formSlideActions[slideId] || slideTitle;
  const label = formSlideActions[slideId] ? 'continue_button' : answerValue;

  sendGAEvent(action, label, stepValue);
}

/**
 * Traccia il successo dell'invio del form
 */
export function trackSliderSuccess(): void {
  sendGAEvent('slider-success', 'form_submit_button', '100');
}

/**
 * Traccia il fallimento dell'invio del form
 */
export function trackSliderFailure(): void {
  sendGAEvent('slider-failure', 'form_submit_button');
}

/**
 * Traccia la creazione di un lead con email hashata
 */
export async function trackLeadCreated(
  email: string,
  phone: string,
  zipCode: string,
  firstName: string,
  lastName: string
): Promise<void> {
  try {
    const [hashedEmail, hashedPhone, hashedFirstName, hashedLastName] = await Promise.all([
      hashSHA256(email),
      hashSHA256(phone.replace(/\s/g, '')),
      hashSHA256(firstName.toLowerCase()),
      hashSHA256(lastName.toLowerCase()),
    ]);
    pushToDataLayer({
      event: 'enpal-lead-created',
      eventModel: {
        eventCategory: 'Formslider',
        leadsUserData: {
          sha256_email_address: hashedEmail,
          sha256_phone_number: hashedPhone,
          sha256_first_name: hashedFirstName,
          sha256_last_name: hashedLastName,
          zipcode: zipCode,
        },
      },
    });
  } catch (error) {
    console.error('Error tracking lead created:', error);
  }
}

/**
 * Traccia la sorgente UTM iniziale
 */
export function trackEnpalSourceCookie(source: string): void {
  sendGAEvent('Enpal Source Cookie', source, '0');
}

/**
 * Traccia il click sul pulsante "Chiamaci Ora"
 */
export function trackCallButtonClick(): void {
  pushToDataLayer({
    event: 'gaEvent',
    eventCategory: 'Formslider',
    eventAction: 'ThankYouPage',
    eventLabel: 'CallMe_Button',
    eventValue: 'click',
  });
}

/**
 * Traccia il click sul pulsante "Scarica l'app"
 */
export function trackAppDownloadClick(): void {
  pushToDataLayer({
    event: 'gaEvent',
    eventCategory: 'Formslider',
    eventAction: 'App_download',
    eventLabel: 'App_download',
    eventValue: 'click',
  });
}